export function voteAlert(patient) {
  if (!patient) {
    return {
      hasEmergencyDevice: false,
      hasEmergencyAlert: false,
      votedAlert: null,
    };
  }

  const hasDevices = patient.devices && patient.devices.length > 0;
  const hasEmergencyDevice = hasDevices
    ? patient.devices.find((d) => d.deviceVersion && d.deviceVersion.category === 'EMERGENCY_BUTTON')
    : null;

  let alertWithEmergency =
    hasEmergencyDevice &&
    hasEmergencyDevice.action &&
    hasEmergencyDevice.action.alerts.length > 0 &&
    hasEmergencyDevice.action.alerts.find((a) => a.alertType === 514);
  if (alertWithEmergency) {
    alertWithEmergency = {
      ...alertWithEmergency,
      routerSerial: hasEmergencyDevice.action ? hasEmergencyDevice.action.routerSerial : '',
      warningSetting: {
        noMovementForTime: patient.warningSetting ? patient.warningSetting.noMovementForTime : 0,
      },
    };
  }

  const alertWithoutEmergency = [];
  hasDevices &&
    patient.devices.forEach((d) => {
      if (d.action && d.action.alerts) {
        d.action.alerts.forEach((a) => {
          if (a.alertType !== 514 && a.alertType !== 513) {
            alertWithoutEmergency.push({
              ...a,
              routerSerial: d.action.routerSerial,
              warningSetting: {
                noMovementForTime: patient.warningSetting ? patient.warningSetting.noMovementForTime : 0,
              },
            });
          }
        });
      }
    });

  const votedAlertWithoutEmergency =
    alertWithoutEmergency.length > 0
      ? alertWithoutEmergency.reduce((a, b) => {
          if (a.alertPriority === b.alertPriority)
            return {
              alertPriority: a.alertPriority,
              alertTime: a.alertTime >= b.alertTime ? a.alertTime : b.alertTime,
              alertType: a.alertTime >= b.alertTime ? a.alertType : b.alertType,
              alertWarning: a.alertTime >= b.alertTime ? a.alertWarning : b.alertWarning,
              alertCritical: a.alertTime >= b.alertTime ? a.alertCritical : b.alertCritical,
              routerSerial: a.alertTime >= b.alertTime ? a.routerSerial : b.routerSerial,
              warningSetting: {
                noMovementForTime:
                  a.alertTime >= b.alertTime ? a.warningSetting.noMovementForTime : b.warningSetting.noMovementForTime,
              },
            };
          if (a.alertPriority < b.alertPriority) return a;
          return b;
        })
      : null;

  const votedAlert = votedAlertWithoutEmergency ? votedAlertWithoutEmergency : alertWithEmergency;
  return {
    hasEmergencyDevice: hasEmergencyDevice ? true : false,
    hasEmergencyAlert: alertWithEmergency ? true : false,
    votedAlert,
    alertWithEmergency,
  };
}
// alertLevel = critical
export function hasAlertType(devices, alertLevel) {
  const hasAlert = devices.filter((d) => {
    if (d.action && d.action.alerts.length > 0) {
      return d.action.alerts.find((a) => a.alertType !== 513 && a[alertLevel] === 'true');
    }
    return false;
  });
  return hasAlert.length > 0;
}
